import React, { memo, useCallback } from 'react';
import { Typography } from '@/components/ui/Typography';
import { BaseLink } from '@/components/ui/BaseLink';
import { URLS } from '@/constants/Strings';

export const FooterLinks: React.FC = memo(() => {
  const openCookieSettings = useCallback(() => window.OneTrust?.ToggleInfoDisplay(), []);

  return (
    <nav className="footer__nav">
      <ul className="footer__nav-list">
        <li>
          <ul className="footer__nav-inner-list">
            <li className="footer__nav-list-item">
              <BaseLink href={URLS.KNOWLEDGE_BASE} target="_blank">
                <Typography size={14} fontFamily="dm-sans">
                  Help
                </Typography>
              </BaseLink>
            </li>
            <li className="footer__nav-list-item">
              <BaseLink href="/privacy-policy" target="_blank">
                <Typography size={14} fontFamily="dm-sans">
                  Privacy Policy
                </Typography>
              </BaseLink>
            </li>
            <li className="footer__nav-list-item">
              <BaseLink href="/terms-general" target="_blank">
                <Typography size={14} fontFamily="dm-sans">
                  Terms of Use
                </Typography>
              </BaseLink>
            </li>
          </ul>
        </li>

        <li>
          <ul className="footer__nav-inner-list">
            <li className="footer__nav-list-item">
              <BaseLink href="/cookies" target="_blank">
                <Typography size={14} fontFamily="dm-sans">
                  Cookie Policy
                </Typography>
              </BaseLink>
            </li>
            <li className="footer__nav-list-item">
              <BaseLink href="/data-processing" target="_blank">
                <Typography size={14} fontFamily="dm-sans">
                  Data Processing
                </Typography>
              </BaseLink>
            </li>
            <li className="footer__nav-list-item">
              <button type="button" onClick={openCookieSettings}>
                <Typography size={14} fontFamily="dm-sans">
                  Cookie Settings
                </Typography>
              </button>
            </li>
          </ul>
        </li>
      </ul>

      {/* Style */}

      <style jsx>
        {`
          .footer {
            @apply flex flex-none w-full py-16 h-auto;

            &__nav-list {
              @apply flex flex-col md:flex-row gap-y-5 gap-x-20 lg:gap-x-40 text-left;
            }

            &__nav-inner-list {
              @apply flex flex-col gap-y-5;
            }

            &__nav-list-item {
              @apply flex flex-col gap-y-2;
            }

            &__nav-list-item {
              :global(a:hover),
              :global(button:hover) {
                @apply text-indigo-700;
              }
            }
          }
        `}
      </style>
    </nav>
  );
});
